
import { FunnelsServices } from "@/services";
import Vue from "vue";
export default Vue.extend({
  data() {
    return {
      locationId: "",
      domainId: "",
      loading: false
    };
  },
  methods: {
    async releaseDomain() {
      try {
        this.loading = true;
        const { data } = await FunnelsServices.deleteDomain({
          locationId: this.locationId,
          domainId: this.domainId
        });
        this.loading = false;
      } catch (error) {
        console.error(error);
        this.loading = false;
      }
    }
  }
});
